import { InjectionToken } from '@angular/core';

import { HubInfoConfig } from '../../../api';

/**
 * URL to access the API layer
 *
 * Naming of this field according to the field in the rendering context
 *
 * @example 'https://my.digitalexperience.ibm.com/api/345563cf-a83c-40e5-a065-1d6ff36b05c1'
 * @example 'https://my.digitalexperience.ibm.com/api/345563cf-a83c-40e5-a065-1d6ff36b05c1/dxsites/mysite'
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_API_URL = 'D86BA418-5252-45BB-938C-E17BBE044D0F';

/**
 * URL to access the delivery
 *
 * Naming of this field according to the field in the rendering context
 *
 * @example 'https://my.digitalexperience.ibm.com/345563cf-a83c-40e5-a065-1d6ff36b05c1'
 * @example 'https://my.digitalexperience.ibm.com/345563cf-a83c-40e5-a065-1d6ff36b05c1/dxsites/mysite'
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_DELIVERY_URL = '4BEFD6AD-FA4C-42D7-8C4C-2DCA38CDB499';

/**
 * URL that represents the base URL of the path based routing of the application. This prefix will be
 * preserved when generating and recognizing URLs. If this property is not configured, then it will be decoded
 * from the window location.
 *
 * @example 'https://my.digitalexperience.ibm.com/345563cf-a83c-40e5-a065-1d6ff36b05c1'
 * @example 'https://my.digitalexperience.ibm.com/345563cf-a83c-40e5-a065-1d6ff36b05c1/dxsites/mysite'
 * @example 'https://my.external.example.com/'
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_BASE_URL = 'F5EBA2A4-2C6F-4FEF-B3D5-3C801CB1F2EB';

/**
 * Optionally specify how the SDK makes outbound requests
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_HTTP_OPTIONS = '536C2178-F41A-4F56-AF89-83B52E5274D9';

/**
 * Optionally specify how the SDK makes outbound requests for the preview case
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_HTTP_PREVIEW_OPTIONS =
  '3AC667BA-FBAE-426D-BE7C-00DF1364280D';

/**
 * Optionally specify how the SDK is supposed to deal with
 * cyclic references in the content data structure. Per default
 * the rendering context will break cycles by representing the duplicate
 * element in a reference path by an unresolved reference. When configuring
 * the strategy to {@link CYCLE_HANDLING.RESOLVE}, the {@link ContentrefComponent}
 * will use a resolved refence when rendering the context, instead of the unresolved
 * reference. This bears the risk of an infinite loop during rendering. The
 * actual rendering context objects will still not have cycles, so a JSON serialization
 * of these objects will produce a valid result.
 *
 * Default is {@link CYCLE_HANDLING.BREAK}
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_CYCLE_HANDLING_STRATEGY =
  'FAB70C09-F04A-4702-A8CC-87D3A3CED224';

/**
 * Number of levels to fetch per request to the rendering context. If missing
 * all levels will be fetched.
 *
 * @see [[HubInfoConfig]]
 */
export const WCH_TOKEN_FETCH_LEVELS = '62906A7D-0DE3-4404-AE7C-89E5FD91C72D';

export const WCH_HUB_INFO_CONFIG = new InjectionToken<HubInfoConfig>(
  'HubInfoConfig'
);
